import Vue from 'vue';
import appConfig from 'appConfig';
// import Legend from '../legend/Legend';
// import ForestTable from '../forest/ForestTable';
export default {
  name: 'MapSelect',
  components: {
    // Legend,
    // ForestTable,
  },
  props: {
    center: {
      type: Array,
      default: () => [],
    },
    zoom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      map: {},
      zxmarkerLayer: {},
      currentcity: '湖北',
      isLoaded: false,
    };
  },
  mounted() {
    this.initMapSelect();
  },
  created() {
    this.mapselectData = [];
    // this.mapselectData = config.selCity;
  },
  methods: {
    //地图选择初始化
    initMapSelect() {

    },
    /**
     * @author
     * @description 定位选择城市事件
     * @param item 选择的城市信息
     */
    clickselectData(item) {
      var cityname = item.name;
      // 判断选择的城市没给dom添加选择框
      for (var i = 0; i < this.mapselectData.length; i++) {
        this.mapselectData[i].select = '';
        if (this.mapselectData[i].name === cityname) {
          this.mapselectData[i].select = 'selected';
        }
      }
      if (item.attribute != '') {
        var cityzoom = item.attribute.split(',');
        var citycenter = [parseFloat(cityzoom[0]), parseFloat(cityzoom[1])];
        citycenter = this.$olmap.proj.transform(citycenter, 'EPSG:4326', 'EPSG:3857');
        this.olmap.getView().setCenter(citycenter);
        this.olmap.getView().setZoom(10);
        this.currentcity = cityname;
        // 给该点添加气泡
        this.zxmarkerLayer = new this.$olmap.layer.Vector({
          id: '__marker',
          // zIndex: 1001,
          source: new this.$olmap.source.Vector(),
          style: new this.$olmap.style.Style({
            image: new this.$olmap.style.Icon({
              anchor: [0.5, 46],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels',
              src: '../../../static/maptool/iconposition.png',
            }),
          }),
        });
        this.olmap.setTarget('basemap');
        this.olmap.addLayer(this.zxmarkerLayer);
        var markersource1 = this.zxmarkerLayer.getSource();
        markersource1.clear();
        // 构建feature
        var iconFeature = {
          type: 'Feature',
          properties: {
            name: '树德山庄',
            district: '东安县',
            reclassify: '国家级景点',
            value: 12,
          },
          geometry: {
            type: 'Point',
            coordinates: citycenter,
          },
        };
        var geojson_format = new this.$olmap.format.GeoJSON();
        markersource1.addFeatures(geojson_format.readFeatures(iconFeature));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mapselect/MapSelect.js